import { gql } from "apollo-angular";

const FILTER_USER_LOG = gql`
query UserLogs(
  $company: ID!,
  $operation: UserLogOperations,
  $startDatetime: DateTime,
  $endDatetime: DateTime,
  $userUserName: String,
  $targetUsername: String,
	$first: Int,
	$cursor: String
  ){
  userLogs(
	company: $company,
    operation: $operation,
 	datetime_Gte: $startDatetime,
    datetime_Lte: $endDatetime,
    user_Username_Icontains: $userUserName,
	targetUser_Username_Icontains: $targetUsername,
		first: $first,
		after: $cursor
	){
    pageInfo{
			hasNextPage
			hasPreviousPage
			startCursor
			endCursor
		}
		count
		total
		edges{
            node{
                user{
                    id
                    username
                    email
                }
                targetUser{
                    id
                    username
                    email
                }
                email
                operation
                companiesAdd
                companiesRemove
                permissions
				groups
                changeIsActive
                changeIsSuperuser
                changePassword
                datetime
            }
        }
    }
}`;

const FILTER_USER_TRACE_LOG = gql`
query UserTraceLog(
	$company: ID
	$user_Username_Icontains: String
	$datetime_Gte: DateTime
	$datetime_Lte: DateTime
	$query_Icontains: String
	$before: String
	$after: String
	$first: Int
	$last: Int
) {
	userTraceLog(
		user_Username_Icontains: $user_Username_Icontains
		company: $company
		datetime_Gte: $datetime_Gte
		datetime_Lte: $datetime_Lte
		query_Icontains: $query_Icontains
		before: $before
		after: $after
		first: $first
		last: $last
	) {
		count
		total
		pageInfo{
			hasNextPage
			hasPreviousPage
			startCursor
			endCursor
		}
		edges {
			node {
				datetime
				user {
					id
					username
				}
				operation
				userAgent
				userAddress
				query
				payload
			}
		}
	}
}`;

const FILTER_INSTALLATION_LOG = gql`
query InstallationLog(
	$company: ID!
	$operation: Operations
	$startDatetime: DateTime
	$endDatetime: DateTime
	$username: String
	$pageSize: Int
	$cursor: String
	$installationID: ID
) {
	installationLog(
		company: $company
		operation: $operation
		startDatetime: $startDatetime
		endDatetime: $endDatetime
		username: $username
		pageSize: $pageSize
		cursor: $cursor
		installationId: $installationID
	) {
		pageInfo {
			hasNextPage
			hasPreviousPage
			startCursor
			endCursor
		}
		count
		total
		edges {
			node {
				id
				installationId
				operation
				equipmentSerialNumber
				previousEquipmentSerialNumber
				reference
				siteReference
				gatewayReference
				username
				isActive
				lampModel
				logDatetime
				divisionReference
				company {
					name
				}
			}
		}
	}
}`;

const FILTER_EQUIPMENT_LOG = gql`
query EquipmentLog(
  $company: ID!,
  $operation: Operations,
  $startDatetime: DateTime,
  $endDatetime: DateTime,
  $serialNumber: String,
  $macAddress: String,
  $username: String,
  $pageSize: Int,
  $cursor: String
  ){
    equipmentLog(
      company: $company,
      operation: $operation,
      startDatetime: $startDatetime,
      endDatetime: $endDatetime,
      serialNumber: $serialNumber,
      macAddress: $macAddress,
      username: $username,
      pageSize: $pageSize,
      cursor: $cursor
      ){
        pageInfo{
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        count
		    total
        edges{
            node{
                operation
                serialNumber
                macAddress
                username
                logDatetime
                company{
                    id
                    name
                    cnpj
                }
            }
        }
    }
}`;

const FILTER_INSTALLATION_SITE_LOG = gql`
query InstallationSiteLog(
  $company: ID!,
  $operation: Operations,
  $startDatetime: DateTime,
  $endDatetime: DateTime,
  $reference: String,
  $username: String,
  $pageSize: Int,
  $cursor: String
  ){
installationSiteLog(
	company: $company,
	operation: $operation,
	startDatetime: $startDatetime,
	endDatetime: $endDatetime,
	reference: $reference,
	username: $username,
  pageSize: $pageSize,
  cursor: $cursor
		) {
		pageInfo{
			hasNextPage
			hasPreviousPage
			startCursor
			endCursor
		}
		count
		total
		edges{
			node{
				geoposition{
					latitude
					longitude
				}
				operation
				reference
				username
				isActive
				logDatetime
				company{
					name
				}
			}
		}
	}
}`;

export {
	FILTER_USER_LOG,
	FILTER_USER_TRACE_LOG,
	FILTER_INSTALLATION_LOG,
	FILTER_EQUIPMENT_LOG,
	FILTER_INSTALLATION_SITE_LOG
}